import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { FlatPage } from '../Models/flatpage';
import { Observable } from 'rxjs/Observable';
import { LanguageService } from './lang';


@Injectable()
export class PageService {

  constructor(private http: HttpClient,
              private config: Config,
              private languageService: LanguageService) {}

  get(id: string): Observable<FlatPage> {

    return this.languageService.getLanguage().flatMap(
      value => {
        return this.http.get<FlatPage>(
          `${this.config.getURL('pages')}${id}/`);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/page.ts